import { useState } from "react";
import { api } from "../lib/api";
import { useLang } from "../context/LangContext";
import { OrderView } from "./OrderConfirmation";

export default function TrackOrder() {
  const { t } = useLang();
  const [num, setNum] = useState("");
  const [phone, setPhone] = useState("");
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(false);
    try {
      const { data } = await api.get(`/orders/${num.trim()}`, { params: { phone } });
      setOrder(data);
    } catch {
      setOrder(null);
      setErr(true);
    }
  };

  return (
    <div data-testid="track-order-page" className="container-q pb-28 pt-16">
      <h1 className="text-4xl sm:text-5xl">{t("track_order")}</h1>
      <p className="mt-3 text-sm text-ink/70">{t("track_desc")}</p>
      <form onSubmit={submit} className="mt-10 grid max-w-2xl gap-6 sm:grid-cols-3 sm:items-end">
        <input data-testid="track-order-number-input" required value={num} onChange={(e) => setNum(e.target.value)} placeholder="QM10001" dir="ltr" className="field" />
        <input data-testid="track-phone-input" required value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="05XXXXXXXX" dir="ltr" className="field" />
        <button data-testid="track-submit-button" className="btn-ink">{t("find_order")}</button>
      </form>
      {err && <p data-testid="track-error" className="mt-6 text-sm text-destructive">{t("not_found")}</p>}
      {order && <div className="mt-14"><OrderView order={order} /></div>}
    </div>
  );
}
